import styled from '@emotion/styled';
import CardIncome from './Card';
import { Grid2 } from '@mui/material';
import ReportsHeader from './ReportsHeader';
import { useState } from 'react';
import { isEmpty } from 'lodash';
import CustomIcon from 'components/customIcon';

const reports = [
    {
        period: 'Дохід за період',
        change: {
            percent: -3.6,
            amount: 200334,
        },
        totalIncome: 5001414,
        details: [
            {
                label: 'Готівка',
                amount: '1 000 282,89',
            },
            {
                label: 'Термінал',
                amount: '1 000 282,89',
            },
            {
                label: 'ФОП Дмитриченко А.В. готівка',
                amount: '1 000 282,89',
            },
            {
                label: 'ФОП Дмитриченко А.В. б/н',
                amount: '1 000 282,89',
            },
            {
                label: 'ТОВ Ізімс',
                amount: '1 000 282,89',
            },
        ],
        moreLink: {
            text: 'Детальніше',
            url: '#',
        },
    },
    {
        period: 'Дохід за категоріями номерів',
        change: {
            percent: -3.6,
            amount: 200334,
        },
        totalIncome: 5001414,
        details: [
            {
                label: 'Готівка',
                amount: '1 000 282,89',
            },
            {
                label: 'Термінал',
                amount: '1 000 282,89',
            },
            {
                label: 'ФОП Дмитриченко А.В. готівка',
                amount: '1 000 282,89',
            },
            {
                label: 'ФОП Дмитриченко А.В. б/н',
                amount: '1 000 282,89',
            },
            {
                label: 'ТОВ Ізімс',
                amount: '1 000 282,89',
            },
        ],
        moreLink: {
            text: 'Детальніше',
            url: '#',
        },
    },
];

const Reports = () => {
    const [activeCard, setActiveCard] = useState({});

    return (
        <Styled>
            <ReportsHeader />

            <div className="body">
                {!isEmpty(activeCard) ? (
                    <>
                        <div onClick={() => setActiveCard({})} className="header_inline">
                            <CustomIcon icon="ArrowRightCard" /> {activeCard.period}
                        </div>
                        <CardIncome isMain data={activeCard} />
                    </>
                ) : (
                    <Grid2 container spacing={3}>
                        {reports?.map((data) => (
                            <Grid2 size={{ xs: 12, md: 6 }}>
                                <CardIncome onClick={() => setActiveCard(data)} key={data.period} data={data} />
                            </Grid2>
                        ))}
                    </Grid2>
                )}
            </div>
        </Styled>
    );
};

const Styled = styled.div`
    .header_inline {
        display: flex;
        gap: 5px;
        align-items: center;
        color: #2b3350;
        font-family: Inter;
        font-weight: 500;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: 0%;
        vertical-align: middle;
        margin-bottom: 30px;
        cursor: pointer;

        .icon {
            transform: rotate(180deg);
        }
    }
    .body {
        padding: 32px 40px;
        max-width: 1250px;
        margin: 0 auto;
    }

    @media only screen and (max-width: 767px) {
        .body {
            padding-inline: 30px;
        }
    }
    @media only screen and (max-width: 512px) {
        .body {
            padding-inline: 20px;
        }
    }
`;

export default Reports;
